import { fullApps } from "./full";

export interface AppData {
  id: number;
  title: string;
  subtitle: string;
  rating: number;
  ratingCount: string;
  price: number;
  rank: number;
  color: string;
  icon: string;
}

export const topCharts: AppData[] = [
    ...fullApps
];

export const iconUrl = (title: string, color: string) =>
  `https://ui-avatars.com/api/?name=${encodeURIComponent(title)}&background=${color.slice(1)}&color=fff&size=128`;

export const coverUrl = (seed: string) =>
  `https://picsum.photos/seed/${encodeURIComponent(seed)}/600/450`;

export const screenshotUrl = (seed: string, n: number) =>
  `https://picsum.photos/seed/${encodeURIComponent(`${seed}-${n}`)}/300/650`;